export const WEBSITE = 'WEBSITE';

export const WEBSITE_NAME = 'WEBSITE_NAME';

export const WEBSITE_URL = 'WEBSITE_URL';

export const WEBSITE_BIO = 'WEBSITE_BIO';

export const WEBSITE_TEMPLATE = 'WEBSITE_TEMPLATE';

export const WEBSITE_LINKS = 'WEBSITE_LINKS';

export const WEBSITE_ABOUT = 'WEBSITE_ABOUT';

export const USER = 'USER';

export const ADMIN_USERNAME = 'ADMIN_USERNAME';

export const ADMIN_TOKEN = 'ADMIN_TOKEN';

export const SIGNIN = 'SIGNIN';

export const ROUTE = 'ROUTE';

export const TOKEN = 'TOKEN';

export const IMAGES = 'IMAGES';

export const IMAGES_PREVIEW = 'IMAGES_PREVIEW';

export const ABOUT = 'ABOUT';

export const ABOUT_CONTENT = 'ABOUT_CONTENT';

export const ABOUT_CONTENT_RAW = 'ABOUT_CONTENT_RAW';

export const LINKS = 'LINKS';

export const OPEN = 'OPEN';

export const EDIT = 'EDIT';

export const CUSTOM = 'CUSTOM';

export const SELECT_TOOLBAR = 'SELECT_TOOLBAR';

